import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class LinkToOfferCloseIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 18 18">
                <g>
                    <path fill="black" d="M10.62,8.5l5.94-5.94A1.5,1.5,0,1,0,14.44.44L8.5,6.38,2.56.44A1.5,1.5,0,0,0,.44,2.56L6.38,8.5.44,14.44a1.49,1.49,0,0,0,0,2.12,1.5,1.5,0,0,0,2.12,0L8.5,10.62l5.94,5.94a1.5,1.5,0,0,0,2.12,0,1.49,1.49,0,0,0,0-2.12Z"/>
                </g>
            </SvgIcon>
        );
    }
}